import React, { useState } from 'react';
import latinize from 'latinize';
import {
  Grid,
  TextField,
  CircularProgress,
  Button,
  Typography
} from '@material-ui/core';
import {
  Autocomplete
} from '@material-ui/lab';

import { withPedalsCtx } from '../../organisms/Pedalboard/context';

let debounceTimeout;
const debounce = (func) => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  debounceTimeout = setTimeout(func, 500);
}

const AddPedal = ({ pedalsCtx }) => {
  const [options, updateOptions] = useState([]);
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [queryValue, setQueryValue] = useState('');
  const [focused, setFocused] = useState(false);

  const { pedalsLoading: loading, pedals, addToPedalsList } = pedalsCtx.state;

  const searchByQuery = (value) => debounce(async () => {
    if (value && value.length > 2) {
      const str = latinize(value.toLowerCase());
      const data = pedals.filter(item => (
        latinize(item.name.toLowerCase()).includes(str)
        || latinize(item.brand.toLowerCase()).includes(str)
        ));
      console.log(value, pedals, data);
      updateOptions(data);
    } else {
      updateOptions([]);
    }
  });

  return <div className="textfield-addpedal">
    {console.log('opened', focused, queryValue)}
    {
      loading ? 'Carregando pedais...' : (
        <Autocomplete
          getOptionLabel={(option) => `${option.brand} | ${option.name}`}
          // groupBy={(option) => option.brand}
          onChange={(event, option) => {
            setQueryValue('');
            addToPedalsList(option);
          }}
          options={!queryValue ? [] : options.sort((a, b) => a.name < b.name ? -1 : 1).sort((a, b) => a.brand < b.brand ? -1 : 1)}
          autoHighlight
          noOptionsText={!queryValue ? null : "Nenhum pedal encontrado"}
          includeInputInList
          blurOnSelect={true}
          clearOnBlur={true}
          inputValue={queryValue}
          clearOnEscape={true}
          disableClearable={true}
          open={focused && queryValue}
          renderInput={params => (
            <TextField
              {...params}
              label="Procure seu pedal"
              fullWidth
              onChange={e => {
                setQueryValue(e.target.value);
                searchByQuery(e.target.value);
              }}
              disabled={loading}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              margin="normal"
              InputProps={{
                ...params.InputProps,
                autoFocus: true,
                readOnly: loading,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )
    }
    <Grid container style={{ justifyContent: 'center', marginTop: 16 }} spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body2">
          Ou adicione um tamanho personalizado
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Largura em cm"
          value={width}
          onChange={e => setWidth(e.target.value)}
          type="number"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Altura em cm"
          value={height}
          onChange={e => setHeight(e.target.value)}
          type="number"
        />
      </Grid>
      {
        width && height && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              style={{ width: '100%' }}
              onClick={() => addToPedalsList({ width: +width, height: +height, custom: true })}
            >
              ADICIONAR
            </Button>
          </Grid>
        )
      }
    </Grid>
  </div>;
}

export default withPedalsCtx(AddPedal);